<footer>
  <p class="text-right">©{{date | date: "yyyy"}} <a href="https://fourelagadec.com"> Fouré Lagadec</a></p>
</footer>
